// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__19x7x","range":"MonthRangeSwitch_range__2cPm5","disabled":"MonthRangeSwitch_disabled__3T3Vg"};